import { render, staticRenderFns } from "./productDeatil.vue?vue&type=template&id=5cccca1a&scoped=true&"
import script from "./productDeatil.vue?vue&type=script&lang=js&"
export * from "./productDeatil.vue?vue&type=script&lang=js&"
import style0 from "./productDeatil.vue?vue&type=style&index=0&id=5cccca1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cccca1a",
  null
  
)

export default component.exports